<script>
    import V from 'voUtils/V.js'

    export default {
    	voVueComponent: 'feedback-carousel',
    	props: {
    		carouselId: String
    	},

    	mounted: function() {
    		$("#owl-" + this.carouselId).owlCarousel({
    			items: 1,
    			loop: false,
    			autoplay: false,
    			rewind: true,
    			dots: true,
    			smartSpeed: 1000,
    			nav: false,
    			autoplayTimeout: 10000
    		});
    	}
    };
</script>